import styled from 'styled-components'
import { RiPencilLine } from 'react-icons/ri'
import { useSnapshot } from 'valtio'
import { dashboardStore } from '../../state/dashboardStore'
import useTranslation from '../../hooks/useTranslation'
import { media } from '../../styles/media'

// Wide screens only, like the header title: below that the dashboard keeps
// its own edit button beside its title.
const IconButton = styled.button`
  display: none;
  align-self: center;
  margin-left: 0.5rem;
  border-radius: 50%;
  background-color: ${({ $active, theme }) => $active ? theme.dropdown.active : 'transparent'};
  color: ${({ $active, theme }) => $active ? theme.font.highlight : theme.font.label};
  border: none;
  width: 32px;
  height: 32px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
  &:hover {
    background: ${({ $active, theme }) => $active ? theme.dropdown.active : theme.dropdown.selectedBackground};
  }

  ${media.laptop} {
    display: flex;
  }
`

function HeaderEditToggle() {
  const { t } = useTranslation()
  const snap = useSnapshot(dashboardStore)

  if (!snap.editable) return null

  return (
    <IconButton
      data-testid='header.dashboard.edit'
      $active={snap.editing}
      aria-label={t('all.dashboard.edit.button')}
      title={t('all.dashboard.edit.button')}
      onClick={() => { dashboardStore.editing = !dashboardStore.editing }}
    >
      <RiPencilLine />
    </IconButton>
  )
}

export default HeaderEditToggle
